import vueUIInitiator from '../../../modules/vue-ui-initiator';
import VideoWithPreview from '../../../vue-components/VideoWithPreview';
import EducationArchStudentsMap from '../../../vue-components/EducationArchStudentsMap';
import EducationStudentsList from '../../../vue-components/EducationStudentsList';
import EducationRanhigsStudentsMap from '../../../vue-components/EducationRanhigsStudentsMap';
import ContentSlider from '../../../vue-components/ContentSlider';

vueUIInitiator('js--content-slider', ContentSlider, 'content-slider');
vueUIInitiator('js--video-with-preview', VideoWithPreview, 'video-with-preview');
vueUIInitiator('js--education-arch-students-map', EducationArchStudentsMap, 'education-arch-students-map');
vueUIInitiator('js--education-students-list', EducationStudentsList, 'education-students-list');
vueUIInitiator('js--education-ranhigs-students-map', EducationRanhigsStudentsMap, 'education-ranhigs-students-map');
